/* eslint-disable */
import React, { useState } from "react";
import Select from "react-select";

const MyMeetingFilterPopup = ({
  setfilterMeetingTitle,
  setfilterMeetingType,
  setfilterAgendaDate,
  setfilterSentList,
  setfilterRecieveList,
  setfilterPendingList,
  setfilterAcceptList,
  setfilterTodayList,
  setfilterUpcomingList,
  setfilterPastList,
}) => {
  const meetingTypeOptions = [
    { label: "Meeting Only", value: "1" },
    { label: "Agenda Only", value: "2" },
  ];

  const [fromDate, setfromDate] = useState("");
  const [toDate, settoDate] = useState("");
  const [meetingTitle, setmeetingTitle] = useState("");
  const [meetingType, setmeetingType] = useState("");
  const [meetingTypeValue, setmeetingTypeValue] = useState(null);

  const [sentList, setsentList] = useState(false);
  const [reciveList, setreciveList] = useState(false);
  const [pendingList, setpendingList] = useState(false);
  const [acceptList, setacceptList] = useState(false);

  const [todayList, settodayList] = useState(false);
  const [upcomingList, setupcomingList] = useState(false);
  const [pastList, setpastList] = useState(false);

  //meeting type
  const meetingTypeSeclectionHandler = (val) => {
    if (val) {
      setmeetingTypeValue(val);
      setmeetingType(val.value);
    } else {
      setmeetingTypeValue(null);
      setmeetingType("");
    }
  };

  //function for assign search data for filter and close pop up
  const searchDataHandler = () => {
    //check start date and end date are not empty.If end date empty then only search by start date
    if (fromDate != "" && toDate != "" && fromDate < toDate) {
      setfilterAgendaDate(fromDate + "," + toDate);
    } else if (fromDate != "") {
      setfilterAgendaDate(fromDate);
    }

    if (meetingTitle !== "") {
      setfilterMeetingTitle(meetingTitle);
    }

    if (meetingType != "") {
      setfilterMeetingType(meetingType);
    }

    if (sentList) {
      setfilterSentList(sentList);
    }

    if (reciveList) {
      setfilterRecieveList(reciveList);
    }

    if (pendingList) {
      setfilterPendingList(pendingList);
    }

    if (acceptList) {
      setfilterAcceptList(acceptList);
    }

    if (todayList) {
      setfilterTodayList(todayList);
    }

    if (upcomingList) {
      setfilterUpcomingList(upcomingList);
    }

    if (pastList) {
      setfilterPastList(pastList);
    }

    // close the offcanvas of filter
    let offCanvasPopup = document.querySelector("#offcanvasMyMeetings");
    let offCanvas = bootstrap.Offcanvas.getInstance(offCanvasPopup);
    offCanvas.hide();
    resetHandler();
  };

  //function for reset search
  const resetHandler = () => {
    //     removeActiveClass();
    setfromDate("");
    settoDate("");
    //     settagValues([]);
    setmeetingTitle("");
    setmeetingType("");
    setmeetingTypeValue(null);
    setsentList(false);
    setreciveList(false);
    setpendingList(false);
    setacceptList(false);
    settodayList(false);
    setupcomingList(false);
    setpastList(false);
  };

  return (
    <div className="offcanvas_sidebar">
      <div
        className="offcanvas offcanvas-end body_bg"
        tabIndex="-1"
        id="offcanvasMyMeetings"
        aria-labelledby="offcanvasMyMeetings"
      >
        <div className="offcanvas-header">
          <button
            type="button"
            className="close-btn text-reset filter_cross d-flex align-items-center justify-content-center"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <span className="material-icons-outlined">close</span>
          </button>
        </div>
        <div className="offcanvas-body">
          <div className="filter_outerbx">
            {/* tags */}
            {/* <div className="product_filtr_item mb-3">
              <div className="filter_hdng d-flex align-items-center justify-content-between mb-3">
                <div className="filter_name">
                  <h4 className="fs-sm fw-medium text-primary">Tags</h4>
                </div>
                <span className="accor_arw">
                  <i className="material-icons-outlined">
                    {" "}
                    keyboard_arrow_down
                  </i>
                </span>
              </div>

              <div className="filter_info">
                <div className="filter_list department_info">
                  <ul className="list_style_none d-flex gap-2 flex-wrap">
                    {tagList.map((tag, index) => {
                      return (
                        <li
                          key={index}
                          id={"filtertagli-" + tag.value}
                          onClick={() => {
                            tagSelectionHandler(tag);
                          }}
                          className="filtertagstyle"
                        >
                          {tag.label}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div> */}

            {/* <li className="active">All Sector</li> */}

            {/* <div className="product_filtr_item mb-3">
              <div className="filter_hdng d-flex align-items-center justify-content-between mb-3">
                <div className="filter_name">
                  <h4 className="fs-sm fw-medium text-primary">Created </h4>
                </div>
                <span className="accor_arw">
                  <i className="material-icons-outlined">
                    {" "}
                    keyboard_arrow_down
                  </i>
                </span>
              </div>
              <div className="price_range d-flex gap-2">
                <div className="price_fill">
                  <input
                    type="date"
                    value=""
                    className="form-control"
                    placeholder="From"
                  />
                </div>
                <div className="price_fill">
                  <input
                    type="date"
                    value=""
                    className="form-control "
                    placeholder="To"
                  />
                </div>
                <div className="go_btn">
                  <input
                    type="submit"
                    value="Go"
                    className="go_price btn primary-btn"
                  />
                </div>
              </div>
            </div> */}
          </div>

          {/* date */}
          <div className="product_filtr_item mb-3">
            <div className="filter_hdng d-flex align-items-center justify-content-between mb-3">
              <div className="filter_name">
                <h4 className="fs-sm fw-medium text-primary">
                  Search by Date{" "}
                </h4>
              </div>
              <span className="accor_arw">
                <i className="material-icons-outlined"> keyboard_arrow_down</i>
              </span>
            </div>

            <div className="events_dates d-flex align-items-center gap-2">
              <input
                type="date"
                className="form-control"
                placeholder="From date"
                value={fromDate}
                onChange={(e) => setfromDate(e.target.value)}
              />
              <input
                type="date"
                className="form-control"
                placeholder="To date"
                value={toDate}
                onChange={(e) => settoDate(e.target.value)}
              />
            </div>
          </div>

          {/* title search */}
          <div className="product_filtr_item mb-3">
            <div className="filter_hdng d-flex align-items-center justify-content-between mb-3">
              <div className="filter_name">
                <h4 className="fs-sm fw-medium text-primary">
                  Search by Title{" "}
                </h4>
              </div>
              <span className="accor_arw">
                <i className="material-icons-outlined"> keyboard_arrow_down</i>
              </span>
            </div>

            <div className="form-group">
              <input
                type="text"
                className="form-control"
                placeholder="Search by title"
                value={meetingTitle}
                onChange={(e) => setmeetingTitle(e.target.value)}
              />
            </div>
          </div>

          {/* select type */}
          <div className="product_filtr_item mb-3">
            <div className="filter_hdng d-flex align-items-center justify-content-between mb-3">
              <div className="filter_name">
                <h4 className="fs-sm fw-medium text-primary">
                  Select Meeting Type{" "}
                </h4>
              </div>
              <span className="accor_arw">
                <i className="material-icons-outlined"> keyboard_arrow_down</i>
              </span>
            </div>

            <div className="form-group">
              <Select
                placeholder="Select Meeting type"
                options={meetingTypeOptions}
                value={meetingTypeValue}
                onChange={(val) => {
                  meetingTypeSeclectionHandler(val);
                }}
                isClearable
              />
            </div>
          </div>

          {/* checkbox for meet */}
          {meetingType == "1" ? (
            <div className="product_filtr_item mb-3">
              {/* sent */}
              <div className="form-group mb-2">
                <label className="radio-check">
                  <input
                    type="checkbox"
                    checked={sentList}
                    onChange={(e) => {
                      setsentList(e.target.checked);
                    }}
                  />
                  <span></span>
                  <p className="fs-sm text-primary fw-medium">Sent</p>
                </label>
              </div>

              {/* recieve */}
              <div className="form-group mb-2">
                <label className="radio-check">
                  <input
                    type="checkbox"
                    checked={reciveList}
                    onChange={(e) => {
                      setreciveList(e.target.checked);
                    }}
                  />
                  <span></span>
                  <p className="fs-sm text-primary fw-medium">Recieve</p>
                </label>
              </div>

              {/* pending */}
              <div className="form-group mb-2">
                <label className="radio-check">
                  <input
                    type="checkbox"
                    checked={pendingList}
                    onChange={(e) => {
                      setpendingList(e.target.checked);
                    }}
                  />
                  <span></span>
                  <p className="fs-sm text-primary fw-medium">Pending</p>
                </label>
              </div>

              {/* accepted */}
              <div className="form-group mb-2">
                <label className="radio-check">
                  <input
                    type="checkbox"
                    checked={acceptList}
                    onChange={(e) => {
                      setacceptList(e.target.checked);
                    }}
                  />
                  <span></span>
                  <p className="fs-sm text-primary fw-medium">Accepted</p>
                </label>
              </div>
            </div>
          ) : null}

          {/* checkbox for agenda */}
          {meetingType == "2" ? (
            <div className="product_filtr_item mb-3">
              <div className="form-group">
                {/* todays */}
                <div className="form-group mb-2">
                  <label className="radio-check">
                    <input
                      type="checkbox"
                      checked={todayList}
                      onChange={(e) => {
                        settodayList(e.target.checked);
                      }}
                    />
                    <span></span>
                    <p className="fs-sm text-primary fw-medium">Todays</p>
                  </label>
                </div>

                {/* upcoming */}
                <div className="form-group mb-2">
                  <label className="radio-check">
                    <input
                      type="checkbox"
                      checked={upcomingList}
                      onChange={(e) => {
                        setupcomingList(e.target.checked);
                      }}
                    />
                    <span></span>
                    <p className="fs-sm text-primary fw-medium">Upcoming</p>
                  </label>
                </div>

                {/* Past Schedule */}
                <div className="form-group mb-2">
                  <label className="radio-check">
                    <input
                      type="checkbox"
                      checked={pastList}
                      onChange={(e) => {
                        setpastList(e.target.checked);
                      }}
                    />
                    <span></span>
                    <p className="fs-sm text-primary fw-medium">
                      Past Schedule
                    </p>
                  </label>
                </div>
              </div>
            </div>
          ) : null}

          <button
            type="button"
            className="btn primary-btn fs-sm fw-normal w-100 mt-3"
            onClick={searchDataHandler}
          >
            Search
          </button>
        </div>
      </div>
    </div>
  );
};

export default MyMeetingFilterPopup;
